import React from 'react';
import { Box, Heading, Text } from '@wix/design-system';
import AverageRating from './AverageRating';
import { useTranslation } from '@wix/wix-i18n-config';
import s from './ProfileTemplates.module.scss';

interface ProfileTemplatesHeaderProps {
  isMobileView: boolean;
  averageRating: number;
  totalTemplatesLength: number;
  loadedTemplatesLength: number;
}

const ProfileTemplatesHeader: React.FC<ProfileTemplatesHeaderProps> = ({
  isMobileView,
  averageRating,
  totalTemplatesLength,
  loadedTemplatesLength,
}) => {
  const { t } = useTranslation();

  return (
    <>
      {isMobileView ? (
        <Heading size="medium" as="h2" dataHook="templates-title">
          {t('profile-page-templates-section-header')}
        </Heading>
      ) : (
        <Box gap="4px">
          <Text size="medium" as="h2" weight="bold" dataHook="templates-title">
            {t('profile-page-templates-section-header')}
          </Text>

          <Text
            size="medium"
            weight="bold"
            as="h2"
            className={s.loadedTemplatesLength}
            dataHook="loaded-templates-length"
          >
            {totalTemplatesLength}
          </Text>
          <Box marginLeft="12px">
            <AverageRating averageRating={averageRating} templatesLength={0} />
          </Box>
        </Box>
      )}
    </>
  );
};

export default ProfileTemplatesHeader;
